
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/locking-system/configure/[slug]",
      function () {
        return require("private-next-pages/[locale]/locking-system/configure/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/locking-system/configure/[slug]"])
      });
    }
  